<template>
  <div class='InputInfo'>
    <input-reg
    :value="SelectedProdEdit.code"
    @update:model-value="newValue => ChangeProdEdit({ code: newValue })"
    text="Código"
    :cont="{ textAlign: 'left' }"
    :label="{ marginLeft: '3px' }"
    :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    />
    <input-reg
    :value="SelectedProdEdit.name"
    @update:model-value="newValue => ChangeProdEdit({ name: newValue })"
    :text="Empresa.modelo === 'Modelo 03' ? 'Nome do imóvel' : 'Nome do produto'"
    :cont="{ textAlign: 'left' }"
    :label="{ marginLeft: '3px' }"
    :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    />
    <div style="display: flex">
      <input-reg
      :value="SelectedProdEdit.preco"
      @update:model-value="newValue => ChangeProdEdit({ preco: newValue })"
      text="Preço (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '90%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-reg
      :value="SelectedProdEdit.oferta"
      @update:model-value="newValue => verifyOferta(newValue)"
      text="Preço de oferta (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <div class="crono">
        <crono-icon @click="showCrono=!showCrono"/>
      </div>
    </div>
    <input-crono v-if="showCrono"/>
    <input-text
    :value="SelectedProdEdit.descricao"
    @update:model-value="newValue => ChangeProdEdit({ descricao: newValue })"
    :text="Empresa.modelo === 'Modelo 03' ? 'Descrição do imóvel' : 'Descrição do produto'"
    :label="{ textAlign: 'left', marginLeft: '3px', marginTop: '5px' }"
    :input="{ padding: '2%', fontSize: '18px', width: '95%', border: 'thin solid #CCC', borderRadius: '5px' }"
    />
    <div>
      <visib-prod/>
      <estoque-prod v-if="Theme.name != 'Modelo 03'"/>
      <props-prod v-if="SelectedProdEdit.tipo === 'Variável'"/>
      <input-caracter v-if="Empresa.modelo === 'Modelo 03'"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from './InputReg'
import CronoIcon from '../../Icons/CronoIcon'
import InputCrono from './InputCrono'
import InputText from './InputText'
import VisibProd from './VisibProd'
import EstoqueProd from './EstoqueProd'
import PropsProd from './PropsProd'
import InputCaracter from './InputCaracter'
export default {
  name: 'InputInfo',
  components: { InputReg, CronoIcon, InputCrono, InputText, VisibProd, EstoqueProd, PropsProd, InputCaracter },
  methods: {
    ...mapActions(['ChangeProdEdit', 'PushMsg']),
    verifyOferta (oferta) {
      let preco = parseFloat(this.SelectedProdEdit.preco.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      let of = parseFloat(oferta.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      if(of > preco) {
        this.PushMsg({ msg: 'O valor da oferta não pode ser maior que o valor do produto', color: 'orange' })
        this.ChangeProdEdit({ oferta: 0 })
        return
      }
      this.ChangeProdEdit({ oferta: oferta })
    }
  },
  data () {
    return {
      showCrono: false,
      form: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit', 'Theme', 'Empresa'])
  },
  created () {
    this.ChangeProdEdit({ oferta: this.SelectedProdEdit.oferta.toFixed(2) })
    this.ChangeProdEdit({ preco: this.SelectedProdEdit.preco.toFixed(2) })
  }
}
</script>

<style scoped>
.InputInfo {
  width: 75%;
}

.crono {
  display: flex;
  justify-content: end;
  align-items: end;
}
</style>
